// extracted by mini-css-extract-plugin
export default {"textImages":"RegisterAuditorFormStepFive_textImages__ARDkN","footer":"RegisterAuditorFormStepFive_footer__2mAvS","logo":"RegisterAuditorFormStepFive_logo__FXquL"};